import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../LangContext";

export default function MarqueeStrip() {
    const { t } = useLang();
    const text = t.marquee;
    return (
        <div
            data-testid="marquee-strip"
            className="border-y border-white/10 bg-ink py-6 overflow-hidden"
        >
            <Marquee gradient={false} speed={40}>
                {Array.from({ length: 6 }).map((_, i) => (
                    <span
                        key={i}
                        className="font-graffiti text-3xl md:text-5xl tracking-tight mx-8"
                    >
                        <span className={i % 2 === 0 ? "text-white" : "text-stroke"}>
                            {text}
                        </span>
                        <span className="text-volt mx-6">★</span>
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
